/**
 * Job External Links
 *
 * @package Embark
 * @since   1.0.0
 */

// Define our comment reply funciton.
const emJobLinks = () => {
	const domain = window.location.hostname;
	const jobPage = document.querySelector('.single-job_listing');
	const links = document.querySelectorAll('a');

	if (jobPage) {
		links.forEach((link) => {
			const href = link.getAttribute('href');
			if (href && href.indexOf(domain) === -1) {
				link.setAttribute('target', '_blank');
				link.setAttribute('rel', 'noopener noreferrer');
			}
		});
	}
};

document.addEventListener('DOMContentLoaded', emJobLinks);
